// Configuration constants and values are now defined
// and appended to the config module at startup based on 
// the runtime configuration loaded by Angular's ConfigService
export const EICDataStream3Config = angular.module('EICDataStream3.config', []);